import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { SHOW_MODAL_QUERY_PARAM, MODAL_IDENTIFIER_QUERY_PARAM, CONDUCTOR_FUNCTIONAL_MODAL } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { SlateButton } from "@faire/retailer-visitor-shared/components/SlateElements/Button/SlateButton";
import { SlateText } from "@faire/retailer-visitor-shared/components/SlateElements/Text/SlateText";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { useAssignSettingImprovedFoiExperience } from "@faire/retailer-visitor-shared/settings/useSettingImprovedFoiExperience";
import { Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useCurrentPath } from "@faire/web--source/ui/hooks/useCurrentPath";
import { trackProductMessagingInProductMessageBannerClick } from "@faire/web-api--source/events/productMessaging/click/inProductMessageBanner";
import { trackProductMessagingInProductMessageBannerHover } from "@faire/web-api--source/events/productMessaging/hover/inProductMessageBanner";
import React from "react";
import { useHistory } from "react-router-dom";
// at least 400 ms to count as an intentional hover
var MIN_HOVER_TIME = 400;
export var ImpBanner = function(param) {
    var message = param.message;
    var _cta_and_action_action_open_link_action, _cta_and_action_action;
    var history = useHistory();
    var currentPath = useCurrentPath();
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), isFirstOrderForFaireDirectIncentive = _useFirstOrderIncentiveStore.isFirstOrderForFaireDirectIncentive, isRetailerFoiEligible = _useFirstOrderIncentiveStore.isRetailerFoiEligible;
    var assignSettingImprovedFoiExperience = useAssignSettingImprovedFoiExperience();
    var _React_useState = _sliced_to_array(React.useState(), 2), onMouseEnterTime = _React_useState[0], setOnMouseEnterTime = _React_useState[1];
    var text_segments = message.text_segments, background_color = message.background_color, cta_and_action = message.cta_and_action, _message_campaign_name = message.campaign_name, campaign_name = _message_campaign_name === void 0 ? "" : _message_campaign_name;
    var isFirstOrderIncentiveCampaign = campaign_name === "FIRST_ORDER_INCENTIVE";
    var shouldAssignImprovedFoiExperience = isFirstOrderIncentiveCampaign && !isFirstOrderForFaireDirectIncentive && isRetailerFoiEligible;
    if (shouldAssignImprovedFoiExperience) {
        assignSettingImprovedFoiExperience();
    }
    var onClickHandler = function() {
        var _cta_and_action_action_open_modal_action, _cta_and_action_action;
        trackProductMessagingInProductMessageBannerClick(campaign_name);
        if (cta_and_action === null || cta_and_action === void 0 ? void 0 : (_cta_and_action_action = cta_and_action.action) === null || _cta_and_action_action === void 0 ? void 0 : (_cta_and_action_action_open_modal_action = _cta_and_action_action.open_modal_action) === null || _cta_and_action_action_open_modal_action === void 0 ? void 0 : _cta_and_action_action_open_modal_action.campaign_name) {
            onClickOpenModal();
        }
    };
    var onClickOpenModal = function() {
        var _cta_and_action_action_open_modal_action, _cta_and_action_action;
        var _obj;
        history.replace(currentPath.append((_obj = {}, _define_property(_obj, SHOW_MODAL_QUERY_PARAM, CONDUCTOR_FUNCTIONAL_MODAL), _define_property(_obj, MODAL_IDENTIFIER_QUERY_PARAM, cta_and_action === null || cta_and_action === void 0 ? void 0 : (_cta_and_action_action = cta_and_action.action) === null || _cta_and_action_action === void 0 ? void 0 : (_cta_and_action_action_open_modal_action = _cta_and_action_action.open_modal_action) === null || _cta_and_action_action_open_modal_action === void 0 ? void 0 : _cta_and_action_action_open_modal_action.campaign_name), _obj)).toString());
    };
    var onMouseEnter = function() {
        setOnMouseEnterTime(Date.now());
    };
    var onMouseLeave = function() {
        if (!onMouseEnterTime) {
            return;
        }
        var timeSpent = Date.now() - onMouseEnterTime;
        if (timeSpent > MIN_HOVER_TIME) {
            trackProductMessagingInProductMessageBannerHover(campaign_name);
        }
        setOnMouseEnterTime(undefined);
    };
    return /*#__PURE__*/ _jsx(Flex, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        align: "center",
        style: {
            width: "100%",
            height: "100%",
            padding: getSpacing("1x", "3x"),
            background: getSlateColorToken(background_color)
        },
        "data-test-id": campaign_name ? "".concat(campaign_name, "_BANNER") : undefined,
        children: /*#__PURE__*/ _jsxs("div", {
            style: {
                margin: "0 auto",
                width: "fit-content",
                textAlign: "center"
            },
            children: [
                text_segments.map(function(text_segment) {
                    return /*#__PURE__*/ _jsxs("span", {
                        children: [
                            /*#__PURE__*/ _jsx(SlateText, {
                                textElement: text_segment
                            }),
                            " "
                        ]
                    }, text_segment.text);
                }),
                /*#__PURE__*/ _jsx(SlateButton, {
                    variant: "tertiary",
                    textElement: cta_and_action === null || cta_and_action === void 0 ? void 0 : cta_and_action.cta_text,
                    linkTo: cta_and_action === null || cta_and_action === void 0 ? void 0 : (_cta_and_action_action = cta_and_action.action) === null || _cta_and_action_action === void 0 ? void 0 : (_cta_and_action_action_open_link_action = _cta_and_action_action.open_link_action) === null || _cta_and_action_action_open_link_action === void 0 ? void 0 : _cta_and_action_action_open_link_action.link_url,
                    onClick: onClickHandler
                })
            ]
        })
    });
};
